import PropTypes from "prop-types"
import EngagementLineDataShape from "./EngagementLineDataShape"
import ItemNameValueShape from "./ItemNameValueShape"

const EngagementScoreFullWidthDataShape = {
  overTime: PropTypes.arrayOf(PropTypes.shape(EngagementLineDataShape)).isRequired,
  averages: PropTypes.arrayOf(PropTypes.shape(ItemNameValueShape)).isRequired,
}
export default EngagementScoreFullWidthDataShape



// WEBPACK FOOTER //
// ./src/state/shapes/EngagementScoreFullWidthDataShape.js